export default "__VITE_ASSET__7d85eca1__"